export default __webpack_public_path__ + "static/media/rabbitpng.79a12715.png";